module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    staticClass: "button is-primary is-pulled-right",
    attrs: {
      "to": {
        name: 'bundle-create'
      }
    }
  }, [_vm._v("\n    Add bundle\n  ")]), _vm._v(" "), _c('data-table', {
    attrs: {
      "data-set": _vm.bundles,
      "page-length": 50,
      "columns": [{
          name: 'i',
          type: 'text',
          prop: 'name',
          searchable: false
        },
        {
          name: 'Name',
          type: 'text',
          prop: 'name'
        },
        {
          name: 'Company',
          type: 'text',
          prop: 'company'
        },
        {
          name: 'Updated',
          type: 'date',
          prop: 'updated_at',
          filter: ['moment', ['from', 'now']]
        },
        {
          name: 'Created',
          type: 'date',
          prop: 'created_at',
          filter: ['moment', ['from', 'now']]
        } ]
    },
    scopedSlots: _vm._u([{
      key: "column_i",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'bundle',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_c('div', {
          staticClass: "data-images"
        }, [(props.row.image !== null) ? _c('img', {
          staticClass: "data-image",
          attrs: {
            "src": props.row.image.thumbnail_path
          }
        }) : _vm._e()])])]
      }
    }, {
      key: "column_Name",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'bundle',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_vm._v("\n        " + _vm._s(props.row.name) + "\n      ")])]
      }
    }, {
      key: "column_Company",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(props.row.company !== null ? 'Show on ' + props.row.company + ' ONLY)' : '') + "\n    ")]
      }
    }, {
      key: "controls",
      fn: function(props) {
        return [_c('td', [_c('div', {
          staticClass: "has-text-right"
        }, [_c('a', {
          staticClass: "delete",
          on: {
            "click": function($event) {
              return _vm.deleteBundle(props.row)
            }
          }
        })])])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74fa9012"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/bundles/BundleList.vue
// module id = 554
// module chunks = 0